import React from "react";
import { Locale } from "../../core/api/model";
import { ParticipantDashboard } from "../components";
import { Box, Container } from "@material-ui/core";

interface DashboardProps {
  locale: Locale;
  showErrorModal: (title: string, description: string, raw?: any) => void;
}

export const Dashboard = (props: DashboardProps) => {
  return (

      <Box pt={{xs: 3, md: 6}}
           pb={{xs: 6, md: 10}}
           className='main-background'
           component='main'
      >
          <Container>
              <ParticipantDashboard
                locale={props.locale}
                showErrorModal={props.showErrorModal}
              />
          </Container>
      </Box>
  );
};
